import React from "react"
import PropTypes from "prop-types"
import RichText from "components/elements/richText"
import "./card.scss"

const RoleCard = ({ content, isOpen, onToggle, roleTitle }) => {
  return (
    <div className={`explore-role-card ${isOpen ? "is-open" : ""}`}>
      <button className="explore-role-card__toggle" onClick={onToggle}>
        <div className="explore-role-card__row">
          <span className="explore-role-card__title">{roleTitle}</span>
          <span className="explore-role-card__icon">{isOpen ? "×" : "+"}</span>
        </div>
      </button>

      {isOpen && (
        <div className="explore-role-card__details">
          <RichText className="role-text" richText={{ json: content?.json }} />
        </div>
      )}
    </div>
  )
}

RoleCard.propTypes = {
  content: PropTypes.shape({
    json: PropTypes.object.isRequired,
  }),
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  roleTitle: PropTypes.string.isRequired,
}

export default RoleCard
